export default __webpack_public_path__ + "static/SanAntonio-6f8c23d1f8effedaae036c8eda03ddfe.jpg";